import React, { useEffect, useState } from "react";
import Text from "../Text/Text";
import { Col, Modal, Row } from "antd";
import RenderContent from "../Table/RenderContent";
import styled from "styled-components";
import { groupByCustomerCompanyId } from "../../definitions/groupByCustomerCompanyId";
const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
interface Props {
  visible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  data: any[];
}
const ScrollContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;

function ModalProductDupQuota({ visible, onCancel, onSubmit, data }: Props) {
  const [product, setProduct] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      const grouped = groupByCustomerCompanyId(data);
      setProduct(grouped);
    }
  }, [data]);
  return (
    <ModalStyled
      centered
      visible={visible}
      onCancel={onCancel}
      closeIcon
      width={1000}
      footer={false}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          padding: "22px",
        }}
      >
        <Text align='left' fontWeight={700} fontSize={24}>
          รายการโควตาสินค้าที่ซ้ำ
        </Text>
        <Text align='left' fontWeight={400} fontSize={14} color='background4' fontFamily='Sarabun'>
          หากต้องการเปิดใช้งานโควตาที่เลือก สามารถแก้ไขปัญหาด้วยการปรับเปลี่ยนร้านค้า, สินค้า
          หรือช่วงเวลาไม่ให้ซ้ำซ้อนกัน
        </Text>
      </div>
      <ScrollContainer>
        {product?.map((item) => <RenderContent key={item.id || item.key} data={item} />)}
      </ScrollContainer>
    </ModalStyled>
  );
}

export default ModalProductDupQuota;
